import { atom } from "recoil"

export const AtomLevel = atom({
    key:'ATOMLEVEL',
    default:''
})
  